import { Button } from './ui/button';
import { Switch } from './ui/switch';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from './ui/sheet';
import { Separator } from './ui/separator';
import { BarChart3, Trophy, Menu, Languages } from 'lucide-react';

interface GameHeaderProps {
  darkMode: boolean;
  language: 'pl' | 'ua';
  soundEnabled: boolean;
  onToggleDarkMode: () => void;
  onToggleSound: (value: boolean) => void;
  onChangeLanguage: () => void;
  onShowStats: () => void;
  onShowAchievements: () => void;
  mobileMenuOpen: boolean;
  setMobileMenuOpen: (open: boolean) => void;
  t: {
    stats: string;
    achievements: string;
    darkMode: string;
    sound: string;
    ukrainian: string;
    polish: string;
    menu: string;
  };
}

export function GameHeader({
  darkMode,
  language,
  soundEnabled,
  onToggleDarkMode,
  onToggleSound,
  onChangeLanguage,
  onShowStats,
  onShowAchievements,
  mobileMenuOpen,
  setMobileMenuOpen,
  t
}: GameHeaderProps) {
  return (
    <header className="sticky top-0 z-50 border-b bg-white dark:bg-slate-800">
      <div className="container mx-auto flex items-center justify-between p-4">
        <div className="flex items-center gap-2">
          <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-ua-blue to-ua-yellow flex items-center justify-center">
            <span className="text-white font-bold text-lg">JC</span>
          </div>
          <h1 className="text-xl font-bold hidden sm:block">Japanese Crossword</h1>
        </div>

        <nav className="hidden sm:flex items-center gap-4">
          <Button variant="ghost" size="sm" onClick={onShowStats}>
            <BarChart3 className="w-4 h-4 mr-2" /> {t.stats}
          </Button>
          <Button variant="ghost" size="sm" onClick={onShowAchievements}>
            <Trophy className="w-4 h-4 mr-2" /> {t.achievements}
          </Button>
          <div className="flex items-center gap-2">
            <Switch checked={darkMode} onCheckedChange={onToggleDarkMode} />
            <span className="text-sm">{t.darkMode}</span>
          </div>
          <Button variant="outline" size="sm" onClick={onChangeLanguage}>
            {language === 'pl' ? 'UA' : 'PL'}
          </Button>
        </nav>

        <div className="sm:hidden">
          <Sheet open={mobileMenuOpen} onOpenChange={setMobileMenuOpen}>
            <SheetTrigger asChild>
              <Button variant="ghost" size="icon">
                <Menu className="w-6 h-6" />
              </Button>
            </SheetTrigger>
            <SheetContent className="w-80">
              <SheetHeader>
                <SheetTitle>{t.menu}</SheetTitle>
              </SheetHeader>
              <div className="mt-6 space-y-4">
                <Button variant="ghost" className="w-full justify-start" onClick={() => { onShowStats(); setMobileMenuOpen(false); }}>
                  <BarChart3 className="w-4 h-4 mr-2" /> {t.stats}
                </Button>
                <Button variant="ghost" className="w-full justify-start" onClick={() => { onShowAchievements(); setMobileMenuOpen(false); }}>
                  <Trophy className="w-4 h-4 mr-2" /> {t.achievements}
                </Button>
                <div className="flex items-center justify-between py-2">
                  <span>{t.sound}</span>
                  <Switch checked={soundEnabled} onCheckedChange={onToggleSound} />
                </div>
                <Button variant="outline" className="w-full" onClick={() => { onChangeLanguage(); setMobileMenuOpen(false); }}>
                  {language === 'pl' ? t.ukrainian : t.polish}
                </Button>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
}
